module.exports = __webpack_public_path__ + "static/img/GooglePlay_QR.240f33c5.png";